const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/animaux", {
	title: __("Accueil animaux", "wp-apidae"), // Block title.
	description: __("Affiche un bloc sur l'accueil des animaux", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.pet
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		animauxAcceptes: {
			type: "boolean",
			default: true,
		},
		animauxAcceptesSupplement: {
			type: "boolean",
			default: true,
		},
		descriptifAnimauxAcceptes: {
			type: "boolean",
			default: true,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		ss_field_tag: {
			type: 'string',
			default: 'h3',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<ToggleControl
								label={ __( 'Animaux acceptés' ) }
								checked={ attributes.animauxAcceptes }
								onChange={ () => {
									props.setAttributes({ animauxAcceptes: ! attributes.animauxAcceptes });
								} }
							/>
						<ToggleControl
								label={ __( 'Supplément' ) }
								checked={ attributes.animauxAcceptesSupplement }
								onChange={ () => {
									props.setAttributes({ animauxAcceptesSupplement: ! attributes.animauxAcceptesSupplement });
								} }
							/>
							<ToggleControl
								label={ __( 'Descriptif' ) }
								checked={ attributes.descriptifAnimauxAcceptes }
								onChange={ () => {
									props.setAttributes({ descriptifAnimauxAcceptes: ! attributes.descriptifAnimauxAcceptes });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						<SelectControl
							label={ __( 'Balise des sous titres' ) }
							value={ attributes.ss_field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									ss_field_tag: newValue,
								});
							}}
						/>
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/animaux"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
